// extracted by mini-css-extract-plugin
export default {"illustration":"WUwHjBIAL6eMPjLoHhQE"};